<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-2">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoDepreciacion.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-7 form-group">
				<label>Proveedores</label>	
				<treeselect
					:disabled="DisabledProveedores"
					:maxHeight="100"
					@input="get_proveedores(proveedoresId)"
					:options="ListaProveedores"
					placeholder="Busque un proveedor..."
					v-model="VehiculoDepreciacion.IdProveedor"
					noResultsText="Resultados no encontrados"
					noOptionsText="Opciones no disponibles"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-3">
				<label for="">Número Factura o Recibo</label>
				<input type="text" class="form-control" v-model="VehiculoDepreciacion.NumFactura">
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label for="">Fecha Factura o Recibo *</label>
                <v-date-picker v-model="VehiculoDepreciacion.Fecha" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-2">
				<label> Credito (días) </label>
				<!-- <input
					@input="sumDayPay()"
					class="form-control form-finanza"
					:precision="0"
					v-model="VehiculoDepreciacion.DiasCredito"
					placeholder="0"
				/> -->
				<select v-model="VehiculoDepreciacion.DiasCredito" class="form-control" @change="sumDayPay">
					<option value="0">Contado</option>
					<option value="15">15 días</option>
					<option value="30">30 días</option>
					<option value="60">60 días</option>
					<option value="90">90 días</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha pago *</label>
                <v-date-picker v-model="VehiculoDepreciacion.FechaPago" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Factura</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="facturadepreciacion" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoFactura" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoDepreciacion.Observaciones" cols="10" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Depreciacion",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Depreciacion',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoDepreciacion:{
                IdVehiculoDepreciacion:0,
                IdVehiculo:0,
                Fecha:'',
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:'',
				ArchivoFactura:''
            },
			ArchivoFactura:'',
            errorvalidacion:[],
			ListaProveedores: [],
			IndexPaqueteCta:0,
			DisabledProveedores:false
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
			let FechaPago='';
            if (this.VehiculoDepreciacion.Fecha!='' && this.VehiculoDepreciacion.Fecha!=undefined) {
                let day=this.VehiculoDepreciacion.Fecha.getDate();
                let month=this.VehiculoDepreciacion.Fecha.getMonth()+1;
                let year=this.VehiculoDepreciacion.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.VehiculoDepreciacion.FechaPago!='' && this.VehiculoDepreciacion.FechaPago!=undefined) {
                let day=this.VehiculoDepreciacion.FechaPago.getDate();
                let month=this.VehiculoDepreciacion.FechaPago.getMonth()+1;
                let year=this.VehiculoDepreciacion.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoDepreciacion',this.VehiculoDepreciacion.IdVehiculoDepreciacion);
            formData.set('IdVehiculo',this.VehiculoDepreciacion.IdVehiculo);
            formData.set('Valor',this.VehiculoDepreciacion.Valor);
			formData.set('NumFactura',this.VehiculoDepreciacion.NumFactura);
			formData.set('DiasCredito',this.VehiculoDepreciacion.DiasCredito);
			formData.set('IdProveedor',this.VehiculoDepreciacion.IdProveedor);
            formData.set('Observaciones',this.VehiculoDepreciacion.Observaciones);
			formData.set('ArchivoFactura',this.VehiculoDepreciacion.ArchivoFactura);
            formData.set('Fecha',Fecha);
			formData.set('FechaPago',FechaPago);
			let image=this.$refs.facturadepreciacion.files[0];
			formData.append('ArchivoFacturaFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculodepreciacion/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Depreciacion").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoDepreciacion={
                IdVehiculoDepreciacion:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:new Date(),
				ArchivoFactura:''
            },
			this.ArchivoFactura='Elegir archivo (0.5MB)';
			this.IndexPaqueteCta=0;
			this.DisabledProveedores=false;
        },
		Recuperar(){
            this.$http.get('vehiculodepreciacion/recovery',{
                params:{
                    IdVehiculoDepreciacion:this.VehiculoDepreciacion.IdVehiculoDepreciacion
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculodepreciacion;
                this.VehiculoDepreciacion.IdVehiculoDepreciacion=objres.IdVehiculoDepreciacion;
                this.VehiculoDepreciacion.IdVehiculo=objres.IdVehiculo;
                this.VehiculoDepreciacion.Valor=objres.Valor;
                this.VehiculoDepreciacion.Observaciones=objres.Observaciones;
				this.VehiculoDepreciacion.IdProveedor=objres.IdProveedor == 0 ? null : objres.IdProveedor;
				this.VehiculoDepreciacion.DiasCredito=objres.DiasCredito;
				this.VehiculoDepreciacion.NumFactura=objres.NumFactura;
				this.VehiculoDepreciacion.ArchivoFactura=objres.ArchivoFactura;
				this.VehiculoDepreciacion.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoDepreciacion.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaPago.replace(/-/g, "\/");
                this.VehiculoDepreciacion.FechaPago=new Date(formatedDate2);
				this.ArchivoFactura=objres.ArchivoFactura;

            })
        },
		SubirArchivo(){
			const image = this.$refs.facturadepreciacion.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.facturadepreciacion;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.facturadepreciacion;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoFactura='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoFactura=image.name;
		},
		get_proveedores(id) {
			this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
				});
		},
		sumDayPay() {
			let days = this.VehiculoDepreciacion.DiasCredito;
			let dateParam = this.VehiculoDepreciacion.Fecha;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.VehiculoDepreciacion.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.VehiculoDepreciacion.FechaPago=this.VehiculoDepreciacion.Fecha;
			}
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
			this.get_proveedores();
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoDepreciacion.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoDepreciacion.IdVehiculoDepreciacion = Id;
				this.Recuperar();
			}
			let User=JSON.parse(sessionStorage.getItem("user"));
			this.IndexPaqueteCta=User.listaPaquetesPrincipal.findIndex((element)=>element.Paquete=='Cuentas por Pagar / Administración' || element.Paquete=='Cuentas por Pagar / Operaciones');
			if (this.IndexPaqueteCta==-1) {
				this.DisabledProveedores=true;
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
